// extracted by mini-css-extract-plugin
export default {"title-section":"cy1+XrxXqX","titleSection":"cy1+XrxXqX"};
    if(module.hot) {
      // 1648553881199
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  